import React from 'react'
import { array } from 'prop-types'
import styles from './ImageGrid.module.scss'

const ImageGrid = ({ imageGridItems = [] }) => {
  if (!imageGridItems || !Array.isArray(imageGridItems)) return null

  const formattedImages = imageGridItems
    .map((image) => {
      if (!image || !image.images) return null
      const imageDataArray = Object.values(image.images)[0]
      if (!imageDataArray) return null

      if (!imageDataArray[0]) return null
      const { alt, title, credits } = image
      const { caption } = imageDataArray[0]

      const getImage = (width) => image.images?.[`grid_griditem_${width}`]?.[0]

      const image320 = getImage(320)
      const image640 = getImage(640)
      const image960 = getImage(960)
      const image1280 = getImage(1280)

      if (!image320) return null

      return {
        src: image320.url,
        alt: alt || title || '',
        caption,
        title,
        credits,
        srcSet: `${image320.url} 320w, ${image640?.url || image320.url} 640w, ${
          image960?.url || image640?.url || image320.url
        } 960w, ${
          image1280?.url || image960?.url || image640?.url || image320.url
        } 1280w`,
        sizes: '(max-width: 767px) 33.333vw, (max-width: 1023px) 25vw, 100vw'
      }
    })
    .filter(Boolean)

  if (formattedImages.length === 0) return null

  return (
    <div className={styles.ImageGrid}>
      <div className={styles.GridContainer}>
        {formattedImages.map((image, index) => (
          <div key={`image-grid-item-${index}`} className={styles.GridItem}>
            {/* Skeleton loader */}
            <div className={styles.Skeleton} />

            {/* Image with onLoad handler */}
            <img
              src={image.src}
              alt={image.alt}
              srcSet={image.srcSet}
              sizes={image.sizes}
              loading="lazy"
              className={styles.Image}
            />

            {/* Caption */}
            {(image.caption || image.title || image.credits) && (
              <div className={styles.Caption}>
                {image.title && (
                  <div className={styles.Title}>{image.title}</div>
                )}
                {image.caption && (
                  <div className={styles.CaptionText}>{image.caption}</div>
                )}
                {image.credits && (
                  <div className={styles.Credits}>{image.credits}</div>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

ImageGrid.propTypes = {
  imageGridItems: array
}

export default ImageGrid
